<ng-container *transloco="let t; scope: 'cms'">
  <section class="brands default-padding block margin--bottom-l margin--top-l">
    <div class="default-max-width centered">
      <div class="layout-section-header">
        <div class="layout-section-header-main">
          <h3 class="headline-second">
            {{ data.title }}
          </h3>
        </div>

        <div class="layout-section-header-aside">
          <a href="{{ data.link }}">{{ t("cms.ui-logo-slider.logo-slider.read-more") }} <i class="icon-arrow-6"></i></a>
        </div>
      </div>

      <div>
        <swiper *ngIf="swiperOptions" class="margin--bottom-xl" [config]="swiperOptions">
          <ng-template swiperSlide *ngFor="let logo of data.logos">
            <a href="{{ logo.link }}">
              <img *ngIf="logo.image" [src]="logo.image.url" alt="{{ logo.alternativeText }}" width="300" height="150" />
            </a>
          </ng-template>
        </swiper>

        <div class="swiper-pagination swiper-pagination-{{ data.id }}"></div>
      </div>
    </div>
  </section>
</ng-container>
